import React from 'react';
import style from './labeledCheckbox.module.scss';
import classNames from 'classnames';

interface LabeledCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: JSX.Element;
    containerClassname?: string;
    rightAlignCheckbox: boolean;
    darkBox: boolean;
    borderedBox: boolean;
    highlightError: boolean;
}

const LabeledCheckbox: React.SFC<LabeledCheckboxProps> = ({
    label, containerClassname, rightAlignCheckbox, darkBox, borderedBox, highlightError, ...rest
}) => {
    const onKeyPress = (event: React.KeyboardEvent<HTMLLabelElement>) => {
        if (event.key === ' ') {
            event.currentTarget.click();
        }
    };

    return (
        <label
            className={classNames(style.CheckboxContainer, containerClassname, {
                [style.RightAlignCheckbox]: rightAlignCheckbox
            })}
            tabIndex={0}
            onKeyPress={onKeyPress}
        >
            {label}
            <input
                {...rest}
                type="checkbox"
            />
            <span
                className={classNames(style.Checkbox, {
                    [style.DarkCheckbox]: darkBox,
                    [style.BorderedCheckbox]: borderedBox,
                    [style.ErrorBox]: highlightError
                })}
            />
        </label>
    );
};

export { LabeledCheckbox };
